<template>
  <div
    :class="[`weather-widget__block weather-widget__block--middle ${$mq}`]"
    slot="footer"
  >
    <div class="weather-widget__block-item">
      <r-icon name="wind" :size="20" />
      <r-text>
        {{ `${currentWeather.wind.toFixed(1) || 0} ${$t("ms")}` }}
      </r-text>
    </div>
    <div class="weather-widget__block-item">
      <r-icon name="rain-drop" :size="20" />
      <r-text>
        {{ `${currentWeather.humidity || 0}%` }}
      </r-text>
    </div>
    <div class="weather-widget__block-item">
      <r-icon name="visible-on" :size="20" />
      <r-text>
        {{ ` ${currentWeather.visibility.toFixed(1) || 0} ${$t("km")}` }}
      </r-text>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentWeather: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss">
.weather-widget {
  &__block {
    &--middle {
      display: flex;
      justify-content: space-between;
      .weather-widget__block-item {
        width: 33.3%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        &:nth-child(2) {
          justify-content: center;
        }
        &:last-child {
          justify-content: flex-end;
        }
      }
      .r-text {
        margin-left: 4px;
        font-weight: 600 !important;
        margin-bottom: 0;
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "ms": "м/с",
    "km": "км"
  },
  "en": {
    "ms": "ms",
    "km": "km"
  }
}
</i18n>
